{ "id": "prs10-rb", "name": "SRS PRS10 (commercial rubidium)", "domain": "clock", "states": 3,
  "coefs": { "Q": 0, "F": 0, "N": 2e-11, "B": 2e-13, "K": 0, "D": 0, "R": 1.7e-12 },
  "thermal": { "tempco": 0.001, "tauTh": 900 },
  "source": "SRS PRS10 datasheet: ADEV 2e-11 @1 s, 1e-12 @100 s, 2e-13 @1e4 s; aging <5e-11/month; tempco ~1e-12/°C.",
  "inferred": [] }
